import React from 'react';
import { getColor } from 'core/utils';

const SellingFastIcon = props => (
	<svg
		width={42}
		height={31}
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M24.891 15.134C22.386 4.144 15.848.826 13.597.022c-.255-.1-.509.167-.364.402 1.962 3.686-.544 7.472-4.54 9.282-.399.167-.87.033-1.052-.302-.364-.636-.545-1.307-.473-2.077.037-.436-.508-.704-.871-.369C4.517 8.6 1.212 11.683.777 18.351.304 25.254 7.532 28.94 7.532 28.94c3.413 1.642 7.118 1.44 9.624.335 4.503-2.01 9.406-6.836 7.735-14.14Z"
			fill={getColor("salmon")}
		/>
		<path
			d="M14.352 25.945c1.327-.52 3.05-1.85 3.219-3.595.282-2.865-3.67-3.75-3.021-7.867.028-.26-.142-.468-.396-.364-1.326.547-3.952 1.823-5.392 5.444-1.073 2.657.395 5.002 1.948 6.018 1.045.703 2.428.833 3.642.364Z"
			fill={getColor("cosmos")}
		/>
	</svg>
);

export default SellingFastIcon;